<template>
  <div class="">
    <label v-if="label" class="block text-sm mb-1">
      {{ label }}
      <span v-if="required" class="text-red-500">*</span>
    </label>
    <div class="relative">
      <input
        :id="id"
        :type="type"
        :value="modelValue"
        @input="
          $emit('update:modelValue', ($event.target as HTMLInputElement).value)
        "
        :placeholder="placeholder"
        :required="required"
        :disabled="disabled"
        :readonly="readonly"
        :autocomplete="autocomplete"
        class="block w-full text-[15px] placeholder:text-sm px-3.5 h-12 bg-gray-100/75 rounded-lg focus:outline-2 outline-transparent focus:outline-primary-blue transition-all duration-300"
        :class="{
          'border-gray-300': !hasError,
          'border-red-500': hasError,
          'bg-gray-100 cursor-not-allowed': disabled || readonly,
        }"
      />
      <div
        v-if="isEyeIcon"
        class="absolute top-1/2 -translate-y-1/2 transform mt-1 right-3"
      >
        <button
          @click.prevent="$emit('toggle')"
          type="button"
          name="Show password"
          title="Show password"
          class="cursor-pointer"
        >
          <Icon name="ph:eye" v-if="showPass" size="20" />
          <Icon name="ph:eye-closed" v-else size="20" />
        </button>
      </div>
    </div>
    <p v-if="hasError && errorMessage" class="z-10 text-sm text-red-600">
      {{ errorMessage }}
    </p>
    <p v-if="hint" class="mt-1 text-[10px] text-rose-400">
      {{ hint }}
    </p>
  </div>
</template>

<script lang="ts" setup>
type InputType =
  | "text"
  | "password"
  | "email"
  | "number"
  | "tel"
  | "url"
  | "search"
  | "date"
  | "time"
  | "datetime-local"
  | "month"
  | "week"
  | "color";

withDefaults(
  defineProps<{
    modelValue: string | number;
    id?: string;
    label?: string;
    type?: InputType;
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    autocomplete?: string;
    hasError?: boolean;
    errorMessage?: string;
    hint?: string;
    min?: number;
    isEyeIcon?: boolean;
    showPass?: boolean;
  }>(),
  {
    modelValue: "",
    label: "",
    type: "text",
    placeholder: "",
    required: true,
    disabled: false,
    readonly: false,
    autocomplete: "off",
    hasError: false,
    errorMessage: "",
    hint: "",
    isEyeIcon: false,
    showPass: false,
  },
);

defineEmits(["update:modelValue", "toggle"]);
</script>
